import { i18n, Icons } from "rujira.ui";
import AutoRujira from "../assets/autorujira.png";
import NamiEarn from "../assets/nami_earn.png";
import NamiIndex from "../assets/nami_index.png";
import Liquidy from "../assets/liquidy.png";
import Calc from "../assets/calc.png";
import Coral from "../assets/coral.png";
import Daodao from "../assets/daodao.png";

const shuffleArray = (arr: any[]) =>
  arr
    .map((a) => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map((a) => a[1]);

const launched = [
  <div className="ecosystem">
    <img src={NamiEarn} alt="NAMI Earn Logo" />
    <i18n.p>
      Earning is for Everyone. Non-Custodial institutional-grade strategies, for
      optimized single sided yield without impermanent loss. Simplified for
      everyday users. Earning crypto with your crypto has never been this
      accessible.
    </i18n.p>
    <div>
      <a href="https://www.namifi.app/nami-earn" target="_blank">
        <Icons.LinkAngle />
      </a>
      <a href="https://twitter.com/NamiProtocol" target="_blank">
        <Icons.X />
      </a>
      <a href="https://t.me/NAMIProtocol" target="_blank">
        <Icons.Telegram />
      </a>
      <a href="https://discord.gg/WGgUADfxXR" target="_blank">
        <Icons.Discord />
      </a>
    </div>
  </div>,
  <div className="ecosystem">
    <img src={NamiIndex} alt="NAMI Index Logo" />
    <i18n.p>
      Diversify your portfolio in just one click. Instantly access a wide range
      of on-chain indexes that track your favorite protocols and investment
      themes. Simple, powerful, and tailored to your crypto strategy.
    </i18n.p>
    <div>
      <a href="https://www.namifi.app/nami-index" target="_blank">
        <Icons.LinkAngle />
      </a>
      <a href="https://x.com/Nami_Index_" target="_blank">
        <Icons.X />
      </a>
      <a href="https://t.me/NAMIProtocol" target="_blank">
        <Icons.Telegram />
      </a>
      <a href="https://discord.gg/WGgUADfxXR" target="_blank">
        <Icons.Discord />
      </a>
    </div>
  </div>,
  <div className="ecosystem">
    <img src={Liquidy} alt="Liquidy Logo" />
    <i18n.p>
      Liquidy is a Decentralized Autonomous Organization (DAO) running a series
      of online revenue streams for $LQDY token holders. The first revenue
      streams is Market Making on RUJI Trade orderbook. The second revenue
      stream is a swap router on Rujira.
    </i18n.p>
    <div>
      <a href="https://liquidy.finance" target="_blank">
        <Icons.LinkAngle />
      </a>
      <a href="https://x.com/LiquidyFinance" target="_blank">
        <Icons.X />
      </a>
      <a href="https://t.me/LiquidyFinance" target="_blank">
        <Icons.Telegram />
      </a>
      <a
        href="https://discord.com/channels/1095005002201833495"
        target="_blank">
        <Icons.Discord />
      </a>
    </div>
  </div>,
  <div className="ecosystem">
    <img src={AutoRujira} alt="AutoRujira Logo" className="bigger" />
    <i18n.p>
      Simplifying your DeFi journey with streamlined, automated web3 operations.
      Manage investments and strategies seamlessly from one platform. A host of
      automation tools empowering everyone to maximize portfolio returns.
    </i18n.p>
    <div>
      <a href="https://autorujira.app/" target="_blank">
        <Icons.LinkAngle />
      </a>
      <a href="https://x.com/autorujira" target="_blank">
        <Icons.X />
      </a>
      <a href="https://t.me/autorujira" target="_blank">
        <Icons.Telegram />
      </a>
      <a href="https://discord.gg/P77vPrnWyr" target="_blank">
        <Icons.Discord />
      </a>
      <a href="https://autorujira.medium.com/" target="_blank">
        <Icons.Medium />
      </a>
    </div>
  </div>,
  <div className="ecosystem">
    <img src={Calc} alt="Calc Logo" />
    <i18n.p>
      A powerful decentralized platform offering a range of recurring,
      customisable swap strategies. Set-and-forget investment mechanisms take
      the emotion out of decision making and let your portfolio do the work so
      you can spend more time on the things you love.
    </i18n.p>
    <div>
      <a href="https://calculated.fi" target="_blank">
        <Icons.LinkAngle />
      </a>
      <a href="https://twitter.com/CALC_finance" target="_blank">
        <Icons.X />
      </a>
      <a href="https://t.me/calcprotocol" target="_blank">
        <Icons.Telegram />
      </a>
    </div>
  </div>,
  <div className="ecosystem">
    <img src={Coral} alt="Coral Logo" />
    <i18n.p>
      An entry and exit ramp for Rujira users built for simplicity and speed,
      forgoing the formalities of the traditional financial world. A secure
      platform for crypto users to connect with others and exchange tokens for
      fiat in a decentralized manner.
    </i18n.p>
    <div>
      <a href="https://x.com/CoralP2P" target="_blank">
        <Icons.X />
      </a>
      <a href="https://t.co/OKNStQ1nq4" target="_blank">
        <Icons.Telegram />
      </a>
    </div>
  </div>,
  <div className="ecosystem">
    <img src={Daodao} alt="Dao Dao Logo" />
    <i18n.p>
      Create a DAO to manage your treasury, community, protocol, or entire
      blockchain in just a few clicks. DAODAO support multisig, token-based, and
      NFT-based DAOs that can be as simple or complex as you want.
    </i18n.p>
    <div>
      <a href="https://daodao.zone" target="_blank">
        <Icons.LinkAngle />
      </a>
      <a href="https://twitter.com/DA0_DA0" target="_blank">
        <Icons.X />
      </a>
      <a href="https://discord.daodao.zone" target="_blank">
        <Icons.Discord />
      </a>
      <a href="https://github.com/DA0-DA0" target="_blank">
        <Icons.GitHub />
      </a>
    </div>
  </div>,
];

export const Protocols = () => {
  return (
    <div className="row wrap pad">
      {shuffleArray(launched).map((c, i) => (
        <div className="col-12 col-sm-6 col-lg-4 mt-4" key={`eco_${i}`}>
          {c}
        </div>
      ))}

      {/* <div className="col-12 col-sm-6 col-lg-4 mt-4">
        <div className="ecosystem">
          <span>Soon</span>
          <img src={KujiraIndex} alt="KujiraIndex Logo" />
          
          <i18n.p>
            KujiraIndex is a platform for asset indices. $KJI, the 1st index, is
            a basket of Kujira based tokens enabling easy diversification. More
            indices will launch in future tracking different asset classes.
          </i18n.p>
          <div>
            <a href="https://kujiraindex.io/" target="_blank">
              <Icons.LinkAngle />
            </a>
            <a href="https://twitter.com/KujiraIndex" target="_blank">
              <Icons.X />
            </a>
            <a href="https://winkhub.app/creators/kujiraindex" target="_blank">
              <Icons.Wink />
            </a>
          </div>
        </div>
      </div>

      <div className="col-12 col-sm-6 col-lg-4 mt-4">
        <div className="ecosystem">
          <span>Soon</span>
          <img src={YieldHarbour} alt="YieldHarbour Logo" />
          
          <i18n.p>
            YieldHarbour is a pioneering decentralized finance (DeFi) protocol,
            revolutionizing options trading with its straightforward,
            transparent approach. It's designed for both experienced traders and
            newcomers to DeFi options, ensuring a seamless and user-friendly
            experience.
          </i18n.p>
          <div>
            <a href="https://twitter.com/yieldharbour" target="_blank">
              <Icons.X />
            </a>
          </div>
        </div>
      </div> */}
    </div>
  );
};
